import React from 'react';
import { Layout, Button, Typography, Space } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';

const { Header } = Layout;
const { Title } = Typography;

const AppHeader = () => {
  const navigate = useNavigate();
  
  // 处理登出
  const handleLogout = () => {
    // 清除令牌
    authAPI.logout();
    // 重定向到登录页面
    navigate('/login');
  };
  
  return (
    <Header style={{ 
      background: '#fff', 
      display: 'flex', 
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 24px',
      boxShadow: '0 1px 4px rgba(0,0,0,0.1)'
    }}>
      <Title level={3} style={{ margin: 0 }}>
        工作流管理系统
      </Title>
      
      <Space>
        <Button 
          icon={<LogoutOutlined />} 
          onClick={handleLogout}
        >
          退出登录
        </Button>
      </Space>
    </Header>
  );
};

export default AppHeader; 